export const authReducer = (state, action) => {
    switch (action.type) {
        case 'SET_AUTH':
            return {
                ...state,
                tokenData: action.payload,
                isAuthenticated: true,
            };
        case 'CHECK_AUTH':
            return {
                ...state,
                authChecked: true,
            };
        case 'SET_PROFILE':
            return {
                ...state,
                profile: { ...action.payload },
            };
        case 'LOGOUT':
            return {
                ...state,
                isAuthenticated: false,
                tokenData: '',
                profile: {},
            };
        default:
            return state;
    }
};
